module.exports = __webpack_public_path__ + "img/2.9edb9735.png";